import { Component } from '@angular/core';
import { ContentPageLayout } from '../../shared/layouts/content-page-layout/content-page-layout';

@Component({
  selector: 'app-meal-plan',
  imports: [ContentPageLayout],
  templateUrl: './meal-plan.html',
  styleUrl: './meal-plan.css',
})
export class MealPlan {}
